import {
  UPDATE_START,
  UPDATE_SUCCESS,
  UPDATE_FAILURE,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  CHANGE_START,
  CHANGE_SUCCESS,
  CHANGE_FAILURE,
  REMOVE_LOGO,
  DELETE_START,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  SOCIAL_LOAD_SUCCESS,
  SOCIAL_DELETE_SUCCESS,
  SINGLE_SOCIAL_LOAD_SUCCESS
} from './actions';

import { get, set } from 'lodash';

const initialState = {
  loading: false,
  loadError: null,
  profile: null,
  profileJson: null,
  updating: false,
  updateErrors: null,
  changingCard: false,
  changeErrors: null,
  changed: false,
  isPristine: true,
  deleting: false
};

export default (state = {}, action) => {
  const newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case UPDATE_START:
      newState.updating = true;
      newState.updateErrors = null;
      break;
    case UPDATE_SUCCESS:
      newState.updating = false;
      newState.profile = action.payload;
      newState.profileJson = JSON.stringify(newState.profile);
      break;
    case UPDATE_FAILURE:
      newState.updating = false;
      newState.updateErrors = action.payload;
      break;
    case FETCH_START:
      newState.loading = true;
      newState.profile = null;
      newState.profileJson = JSON.stringify(newState.profile);
      break;
    case FETCH_SUCCESS:
      newState.loading = false;
      newState.profile = action.payload;
      newState.profileJson = JSON.stringify(newState.profile);
      break;
    case FETCH_FAILURE:
      newState.loading = false;
      newState.loadError = action.payload;
      break;
    case CHANGE_START:
      newState.changingCard = true;
      newState.changed = false;
      break;
    case CHANGE_SUCCESS:
      newState.changingCard = false;
      newState.profile.customer = action.payload;
      newState.profileJson = JSON.stringify(newState.profile);
      newState.changed = true;
      break;
    case CHANGE_FAILURE:
      newState.changingCard = false;
      newState.changeErrors = action.payload;
      newState.changed = false;
      break;
    case REMOVE_LOGO:
      let logo = get(newState.profile, 'meta_datas.logo');
      if (logo) {
        newState.profile = set(newState.profile, 'meta_datas.logo.value', null);
        newState.profileJson = JSON.stringify(newState.profile);
      }
      break;
    case DELETE_START:
      newState.deleting = true;
      break;
    case DELETE_SUCCESS:
    case DELETE_FAILURE:
      newState.deleting = false;
      break;
    case SOCIAL_LOAD_SUCCESS:
    case SOCIAL_DELETE_SUCCESS:
      let networks = {};
      for (let i = 0; i < action.payload.length; i++) {
        networks[action.payload[i].type] = action.payload[i];
      }

      newState.profile.channels = networks;
      newState.profileJson = JSON.stringify(newState.profile);
      break;
    case SINGLE_SOCIAL_LOAD_SUCCESS:
      const network = action.payload;
      if (newState.profile.channels[network.type]) {
        newState.profile.channels[network.type] = network;
      }
      newState.profileJson = JSON.stringify(newState.profile);
      break;
    default:
      // oh well!
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/profile/reducer.js